import React from 'react';
import type {List} from 'immutable';
import {Anchor, Button, Heading, Text} from '@albert-io/atomic';

interface Props {
  folders: List<unknown>;
  showNewFoldersModal: () => void;
}

const EmptyModalContents = ({folders, showNewFoldersModal}: Props) => {
  if (!folders.isEmpty()) {
    return (
      <div className='folders-modal-empty-state'>
        <Text color='secondary' size='l'>
          No Results
        </Text>
      </div>
    );
  }
  return (
    <div className='folders-modal-empty-state'>
      <Heading className='mb-x2'>You don&apos;t have any folders yet</Heading>
      <Text color='secondary' size='l'>
        You can use folders to save custom collections of questions.
      </Text>
      <Text color='secondary' size='l'>
        <Anchor href='http://help.albert.io/en/articles/3002392-what-are-folders'>
          Learn more
        </Anchor>
        .
      </Text>
      <Button className='mt-x5' onClick={showNewFoldersModal}>
        Create new folder
      </Button>
    </div>
  );
};

export default EmptyModalContents;
